module.exports = __webpack_public_path__ + "static/img/print-1.9d1d792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/print-1.png
// module id = VNPs
// module chunks = 10